import { render, staticRenderFns } from "./EAD.vue?vue&type=template&id=6fc44c5d&scoped=true&"
import script from "./EAD.vue?vue&type=script&lang=ts&"
export * from "./EAD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc44c5d",
  null
  
)

export default component.exports